import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useI18n } from "@/i18n/I18nProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Plus, GraduationCap } from "lucide-react";

export default function CoursesPage() {
  const { t } = useI18n();
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title: "", duration_hours: "", modality: "aula", description: "", validity_years: "" });

  const load = () => api.get("/courses").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/courses", {
        ...form,
        duration_hours: form.duration_hours ? Number(form.duration_hours) : null,
        validity_years: form.validity_years ? Number(form.validity_years) : null,
      });
      setOpen(false);
      setForm({ title: "", duration_hours: "", modality: "aula", description: "", validity_years: "" });
      toast.success(t("save"));
      load();
    } catch (err) { toast.error(err.response?.data?.detail || "Error"); }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">{t("courses")}</h1>
          <p className="text-muted-foreground text-sm mt-1">{list.length}</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button className="rounded-full btn-lift"><Plus className="w-4 h-4 mr-1.5" /> {t("courses")}</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>{t("courses")}</DialogTitle></DialogHeader>
            <form onSubmit={submit} className="grid grid-cols-2 gap-4">
              <div className="col-span-2"><Label>{t("title")}</Label><Input required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} /></div>
              <div><Label>{t("course_hours")}</Label><Input type="number" value={form.duration_hours} onChange={(e) => setForm({ ...form, duration_hours: e.target.value })} /></div>
              <div><Label>Modalità</Label><Input value={form.modality} onChange={(e) => setForm({ ...form, modality: e.target.value })} /></div>
              <div><Label>Validità (anni)</Label><Input type="number" value={form.validity_years} onChange={(e) => setForm({ ...form, validity_years: e.target.value })} /></div>
              <div className="col-span-2"><Label>{t("description")}</Label><Input value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} /></div>
              <DialogFooter className="col-span-2"><Button type="submit" className="rounded-full btn-lift">{t("save")}</Button></DialogFooter>
            </form>
          </DialogContent>
        </Dialog>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.map((c) => (
          <div key={c.id} className="bg-card border border-border rounded-lg p-5 card-hover">
            <div className="w-10 h-10 rounded-md bg-secondary/10 text-secondary grid place-items-center mb-3"><GraduationCap className="w-5 h-5" /></div>
            <div className="font-semibold">{c.title}</div>
            <div className="text-xs text-muted-foreground mt-1">{c.duration_hours || "—"}h · {c.modality || "—"}</div>
            {c.description && <div className="text-xs text-muted-foreground mt-2 line-clamp-2">{c.description}</div>}
          </div>
        ))}
        {list.length === 0 && <div className="text-sm text-muted-foreground">{t("no_data")}</div>}
      </div>
    </div>
  );
}
